import { useMemo } from "react"
import styled from "styled-components"
import EmbedDisplay from "./EmbedDisplay"

const Padding = styled.div`
  left: 0;
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
`

const Iframe = styled.iframe`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  border: 0;
`

const vimeoRe =
  /https:\/\/vimeo\.com\/(?<vimeoId>\d+)(\/(?<vimeoSubId>[a-zA-Z0-9]+))?/

// HACK ALERT: workaround for iframelye or vimeo bug: https://linear.app/pathwright/issue/SUP-707/bug-iframely-invalid-cache
function VimeoEmbedView({ data }) {
  const url = data.url

  const src = useMemo(() => {
    const { vimeoId, vimeoSubId } = data.url.match(vimeoRe).groups
    let src = `https://player.vimeo.com/video/${vimeoId}`
    // What is the "vimeoSubId"?
    if (vimeoSubId) {
      src += `?h=${vimeoSubId}`
    }
    return src
  }, [url])

  return (
    <div>
      <Padding>
        <Iframe
          src={src}
          allowfullscreen
          scrolling="no"
          allow="encrypted-media *; autoplay; fullscreen; picture-in-picture; clipboard-write"
        ></Iframe>
      </Padding>
    </div>
  )
}

const EmbedView = ({ layout, data }) => {
  // HACK ALERT: workaround for iframelye or vimeo bug: https://linear.app/pathwright/issue/SUP-707/bug-iframely-invalid-cache
  if (data.url && vimeoRe.test(data.url)) {
    return <VimeoEmbedView data={data} />
  }

  return (
    <EmbedDisplay layout={layout || "center"} embedCode={data.embed_code} />
  )
}

export default EmbedView
